import React from 'react'
import {compose } from 'recompose'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
//import _ from 'lodash'
//import Button from '@material-ui/core/Button'


const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
      rowContent: {
        marginBottom: '0.8em',
        padding: '0.2em',
        borderBottom: '2px solid #3f51b5',
        
    
    },
    subheadline: {
        backgroundColor: theme.palette.secondary.main,
        padding: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        color: 'white',
        textWeight: 'bold'
        
    }
})

const CanidateDetails = (props) => {
    const { classes, canidate, subheadline } = props
    
    /*
    //eslint-disable-next-line
    const connectAltCanidate = () => {
        const { currentOpenEvent } = props
        
        const connectData = {
            canidateId: canidate.id,
            canidateName: canidate.name,
            adminId: currentAdmin.id,
            adminName: currentAdmin.name,
            requesterId: currentOpenEvent.event.userId,
            requesterName: currentOpenEvent.requester.name,
            event: currentOpenEvent.event,
            canidatesOnWait: currentOpenEvent.canidates
            
        }
      
        // handleAltCanidateSelected(connectData)

    } */
    return (
        <Paper className={classes.paper}>
            <Typography variant="headline" color='primary' gutterBottom>
                    Helfer (Angebot)
            </Typography>   
            
                {subheadline 
                    ? <Typography className={classes.subheadline} variant='subheading' color='primary'>{subheadline}</Typography>
                    : null}
            {canidate
                ?<div>
                    <Typography variant='subheading'>
                        <div  className={classes.rowContent}>{canidate.name}</div>
                        <div  className={classes.rowContent}>{canidate.strasse}</div>
                        <div  className={classes.rowContent}>{canidate.ort}</div>
                        <div  className={classes.rowContent}>{canidate.email}</div>
                        <div  className={classes.rowContent}>{canidate.telefon}</div>
                    </Typography>
                  
                </div>
                : <div  className={classes.rowContent}> Wählen Sie einen Bewerber</div>
            }
        </Paper>)
}




export default compose(
    withStyles(styles)
)(CanidateDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEventsDetails/CanidatesDetails.js